import { render, staticRenderFns } from "./PersonaCard.vue?vue&type=template&id=ba8444f0&scoped=true&"
import script from "./PersonaCard.vue?vue&type=script&lang=js&"
export * from "./PersonaCard.vue?vue&type=script&lang=js&"
import style0 from "./PersonaCard.vue?vue&type=style&index=0&id=ba8444f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8444f0",
  null
  
)

export default component.exports